const languageData = [
  {
    languageId: 'thailand',
    locale: 'th',
    name: 'ไทย',
    icon: 'th',
    locale_json: {
      th: null,
      en: null,
    },
    list_json: ["th", "en"],
    accept_language: "th;q=1, en;q0.9"
  },
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
    locale_json: {
      en: null,
      th: null,
    },
    list_json: ["th", "en"],
    accept_language: "en;q=1, th;q0.9"
  },
];
export default languageData;
